import { TPropertyType } from '@brickwise/asset-validation/dist/schema/enums';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastSelectField } from 'src/components/mui-overrides/SelectTextField';

interface Props {
  disabled?: boolean;
}

export const RealEstatesPropertyTypeSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  return (
    <DefaultFastSelectField
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.propertyoverview.fields.propertyType.label')}
      fieldName="propertyDetails.propertyType"
      options={[
        {
          value: TPropertyType.firstFloorFlat,
          label: t('general.propertype.firstfloorflat'),
        },
        {
          value: TPropertyType.studioFlat,
          label: t('general.propertype.studioflat'),
        },
        {
          value: TPropertyType.cooperativeFlat,
          label: t('general.propertype.cooperativeflat'),
        },
        {
          value: TPropertyType.loft,
          label: t('general.propertype.loft'),
        },
        {
          value: TPropertyType.duplexHouse,
          label: t('general.propertype.duplexhouse'),
        },
        {
          value: TPropertyType.pentHouse,
          label: t('general.propertype.penthouse'),
        },
        {
          value: TPropertyType.rawAtticFloor,
          label: t('general.propertype.rawatticfloor'),
        },
        {
          value: TPropertyType.flat,
          label: t('general.propertype.flat'),
        },
        {
          value: TPropertyType.atticFlat,
          label: t('general.propertype.atticflat'),
        },
        {
          value: TPropertyType.room,
          label: t('general.propertype.room'),
        },
        {
          value: TPropertyType.commercial,
          label: t('general.propertype.commercial'),
        },
        {
          value: TPropertyType.familyHome,
          label: t('general.propertype.familyhome'),
        },
        {
          value: TPropertyType.apartmentBuilding,
          label: t('general.propertype.apartmentBuilding'),
        },
        {
          value: TPropertyType.loftConversion,
          label: t('general.propertype.loftConversion'),
        },
        {
          value: TPropertyType.demolitionNewConstruction,
          label: t('general.propertype.demolitionNewConstruction'),
        },
      ]}
    />
  );
};
